import { Injectable } from "@angular/core";
import { environment } from "../../../../../../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { RequestTokenService } from "../../../../../../../../../services/request-token.service";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { RegistroContatoSignature } from "../../models/signature/RegistroContatoSignature";
import { HistoricoContatoSignature } from "../../models/signature/HistoricoContatoSignature";
import { FiltroRegistroContatoSignature } from "../../models/signature/FiltroRegistroContatoSignature";
import { RegistroContatoSimplificadoResult } from "../../models/result/RegistroContatoSimplificadoResult";
const API_URL = `${environment.apiUrl}v1/RegistroContato`;

@Injectable({
  providedIn: 'root'
})

export class RegistroContatoService {

  constructor(private http: HttpClient,
    private requestToken: RequestTokenService
  ) {}

  private handleError(error: any): Observable<never> {
    console.error('An error occurred', error);
    return throwError(error);
  }  

  public GetRegistroContatoCliente(clienteId: string): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.get<any>(`${API_URL}/GetRegistroContatoCliente/${clienteId}`, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public UpdateRegistroContatoCliente(signature: RegistroContatoSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/UpdateRegistroContatoCliente`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public InsertHistoricoContato(signature: HistoricoContatoSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/InsertHistoricoContato`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public UpdateHistoricoContato(signature: HistoricoContatoSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/UpdateHistoricoContato`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public GetHistoricoContatoCliente(clienteId: string): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.get<any>(`${API_URL}/GetHistoricoContatoCliente/${clienteId}`, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public UpdateFeedbackContatoCliente(signature: RegistroContatoSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/UpdateFeedbackContatoCliente`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public UpdateRegistroContatoRetornoCliente(signature: RegistroContatoSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/UpdateRegistroContatoRetornoCliente`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public GetTodosRegistroContatoCliente(filtro: FiltroRegistroContatoSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    // Garante que o filtro não seja null e remove propriedades null/undefined
    const filtroLimpo = filtro ? Object.fromEntries(
      Object.entries(filtro).filter(([_, value]) => value != null)
    ) : {};

    return this.http.post<any>(`${API_URL}/GetTodosRegistroContatoCliente`, filtroLimpo, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public GetTodosRegistrosContatoClienteSimplificados(filtro: FiltroRegistroContatoSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    // Garante que o filtro não seja null e remove propriedades null/undefined
    const filtroLimpo = filtro ? Object.fromEntries(
      Object.entries(filtro).filter(([_, value]) => value != null)
    ) : {};

    return this.http.post<any>(`${API_URL}/GetTodosRegistrosContatoClienteSimplificados`, filtroLimpo, options)
    .pipe(
      catchError(this.handleError)
    )
  }
}
